export default (years) => {
  if (years >= 60 && years <= 79) return "X60";
  if (years >= 80 && years <= 119) return "X80";
  if (years >= 120 && years <= 159) return "X120";
  if (years >= 160 && years <= 199) return "X160";
  if (years >= 200 && years <= 239) return "X200";
  if (years >= 240 && years <= 279) return "X240";
  if (years >= 280 && years <= 319) return "X280";
  if (years >= 320) return "X320";
  return "";
};
